export default {

  setReceivingUser(state, payload) {
    state.receivingUser = payload
    if (payload) {
      state.chatMsgList = state.allChatData[state.receivingUser] || []

      if (state.chatMsgList && state.chatMsgList.length > 0) {
        state.chatMsgList.map((item) => {
          item.status = 'read'

          return item
        })
        state.allChatData[state.receivingUser] = state.chatMsgList

      }
    }
  },


  setReceiver(state, payload) {
    if (payload) {
      payload.easemobAccount = payload.easemobAccount.toUpperCase()
      state.receiver = payload
      state.curUserInfo = payload
      // 过滤聊天记录
      this.commit('setReceivingUser', payload.easemobAccount)
    } else {
      state.receiver = {}
      state.curUserInfo = {}
      // 过滤聊天记录
      this.commit('setReceivingUser', '')
    }
  },



  toogleExhibitorDialog(state) {
    state.exhibitorDialogVisible = !state.exhibitorDialogVisible
  },



  setChatEmployeeList(state, payload) {
    state.chatEmployeeList = payload
  },

  // TODO  暂时隐藏
  // setNewMessageStatus(state, payload) {
  //   state.newMessageComing = payload
  // },

  // setNewMailStatus(state, payload) {
  //   state.newMailComing = payload
  // },

  // 员工管理
  setEmployeeDetail(state, payload) {
    if (payload.id) {
      payload.emailmobile = payload.email || payload.mobile
    }
    state.employeeDetail = payload
  }
}
